import { createSelector, createFeatureSelector } from '@ngrx/store';
import { UiState } from './ui.reducer';
import { selectMergedRouteParams } from '../router/selectors';
import { selectAllLocations, selectUser } from '../auth';
import { isSubwayCustomer } from 'src/app/modules/admin/utils/subway.utils';

export const selectUiFeature = createFeatureSelector<UiState>('ui');

export const selectIsSidebarOpened = createSelector(selectUiFeature, state => state.sidebarManuallyOpen);

export const selectSelectedLocationId = createSelector(selectMergedRouteParams, params => {
  return params && 'locationId' in params ? +params.locationId : null;
});

export const selectSelectedLocation = createSelector(selectSelectedLocationId, selectAllLocations, (locationId, locations) =>
  locationId !== null ? locations[locationId] : null,
);

export const selectLocationCustomerId = createSelector(selectUser, selectSelectedLocationId, (user, locationId): number | null => {
  if (!locationId) return null;
  return user.customers.find(cus => !!cus.children.find(loc => loc?.id === locationId))?.id;
});

export const selectIsSubwayCustomer = createSelector(selectLocationCustomerId, customerId =>
  customerId !== null ? isSubwayCustomer(customerId) : false,
);
